import React from "react";
import { Route, Redirect } from "react-router-dom";
import UserSession from "../../../session/UserSession";
import { paths } from "../../paths";

const PrivateRoute = ({
  component: Component,
  exact,
  strict,
  path,
  routeRender,
  ...rest
}) => {
  const userLoggedIn = UserSession.isUserLoggedIn();

  return (
    <Route
      exact={exact}
      strict={strict}
      path={path}
      render={props =>
        userLoggedIn ? (
          routeRender ? (
            <>{routeRender(props)}</>
          ) : (
            <Component {...props} {...rest} />
          )
        ) : (
          <Redirect
            to={{ pathname: paths.LOGIN_PATH, state: { from: props.location } }}
          />
        )
      }
    />
  );
};

export default PrivateRoute;
